export enum CognitoGroups {
  ContentDistributedGeneration = 'DG',
  ContentUtilityScale = 'UT',
  ContentDataCenters = 'DC',
  ContentEurope = 'EUR',
  RegionNA = 'NA',
  RegionEU = 'EUROPE',
  CustomerAPI = 'API',
}

export enum CognitoAttributes {
  FeatureIntelOnly = 'IntelOnly',
}

export const audienceGroups: AudienceGroups[] = [
  CognitoGroups.ContentDistributedGeneration,
  CognitoGroups.ContentUtilityScale,
  CognitoGroups.ContentEurope,
  CognitoGroups.ContentDataCenters,
  CognitoAttributes.FeatureIntelOnly,
  CognitoGroups.RegionEU,
]

export type AudienceGroups = CognitoGroups | CognitoAttributes

export interface RouteAccess {
  path: string
  pageTitle: string
  requiredGroups: AudienceGroups[]
  rejectedGroups: AudienceGroups[]
}

export const routeAccessConfig: RouteAccess[] = [
  {
    path: '/list/iso_queue{/*subPath}',
    pageTitle: 'Interconnection Queues',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/view/iso_queue{/*subPath}',
    pageTitle: 'Interconnection Queues',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/view/queues{/*subPath}',
    pageTitle: 'Interconnection Queues',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
      CognitoGroups.ContentEurope,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/list/ix-queues{/*subPath}',
    pageTitle: 'Interconnection Queues',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
      CognitoGroups.ContentEurope,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/rankings',
    pageTitle: 'Rankings',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/list/signals',
    pageTitle: 'Signals',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
      CognitoGroups.ContentEurope,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/view/signals{/*subPath}',
    pageTitle: 'Signals',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
      CognitoGroups.ContentEurope,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/list/events',
    pageTitle: 'RFP Tracker',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/view/rfp{/*subPath}',
    pageTitle: 'RFP Tracker',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/list/projects',
    pageTitle: 'Project Pipeline',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/view/projects{/*subPath}',
    pageTitle: 'Project Pipeline',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
  {
    path: '/list/transactions',
    pageTitle: 'Transactions',
    requiredGroups: [
      CognitoGroups.ContentUtilityScale,
      CognitoGroups.ContentDistributedGeneration,
      CognitoGroups.ContentDataCenters,
      CognitoGroups.ContentEurope,
    ],
    rejectedGroups: [CognitoAttributes.FeatureIntelOnly],
  },
]
